import { zSNOptionalNullable, zStringOptional } from '@/general/src/other/validation.js'
import { z } from 'zod'

export const zGetInsuranceCampaignsForAdminEndpointInput = z.object({
  cursor: z.number().optional().nullable(),
  limit: z.number().int().positive().default(10),
  insuranceCampaignSn: zSNOptionalNullable,
  insuranceCampaignIssueMessage: zStringOptional,
  insuranceCampaignIssueMessageHash: zStringOptional,
})
